/**
 * `@wetalk/help-widget/anonymous` — what a host needs for an anonymous visitor's grant and request (plan-019 WID-CORE;
 * ED-2; design §31.4.2, §31.8.10): the visitor key and the ALTCHA solver. Not part of the launcher entry, so the
 * launcher chunk stays inside its budget; a host imports it when it asks an anonymous grant (wetalk.io, the portal's
 * signed-out pages) and WID-FEAT's request form uses the same solver.
 */
import { readStored, writeStored } from "./core/environment.js";
import { HELP_STORAGE_KEY } from "./core/path.js";
export { ALTCHA_ALGORITHM, altchaPayloadOf, challengeOf, solveAltcha } from "./panel/altcha-solve.js";
/** The anonymous visitor key is replaced after this long (design §31.8.10: rotated after 24 hours). */
export const HELP_VISITOR_KEY_LIFE_MS = 86_400_000;
const VISITOR_KEY = /^[A-Za-z0-9_-]{22}$/;
function newVisitorKey(random) {
    const bytes = random(new Uint8Array(16));
    let binary = "";
    for (const byte of bytes)
        binary += String.fromCharCode(byte);
    return btoa(binary).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/, "");
}
/**
 * The visitor key for an anonymous grant or request (22 base64url characters), kept in `localStorage` under `wt-hp:k`
 * with the instant it was made, and replaced once it is a day old. With storage blocked, a key for this page load.
 */
export function helpVisitorKeyOf(storage, random, now) {
    const stored = readStored(storage, HELP_STORAGE_KEY.visitorKey);
    if (stored !== null) {
        try {
            const value = JSON.parse(stored);
            if (typeof value === "object" && value !== null) {
                const { k, t } = value;
                if (typeof k === "string" && VISITOR_KEY.test(k) && typeof t === "number" && t <= now && now - t < HELP_VISITOR_KEY_LIFE_MS) {
                    return k;
                }
            }
        }
        catch {
            // A value this module did not write: replaced below.
        }
    }
    const key = newVisitorKey(random);
    writeStored(storage, HELP_STORAGE_KEY.visitorKey, JSON.stringify({ k: key, t: now }));
    return key;
}
//# sourceMappingURL=anonymous.js.map